// extracted by mini-css-extract-plugin
export default {"text":"AppFeedback_text__lZdae"};